import { HttpTransportType, HubConnection, HubConnectionBuilder } from '@microsoft/signalr'
import generalSettings from '../json/general-settings.json';
import SignalRServiceModel from './SignalRServiceModel';
import { TreatmentModel } from './superbit-api-models';

interface Props {
    onNewAssignmentMessage?: Function;
}

const SignalTaskServiceModel = (props: Props) => {
    let apiUrl =  localStorage.getItem('apiUrl')
    const signalRService: SignalRServiceModel = new SignalRServiceModel(undefined)

    SignalRServiceModel.connectionServer.on("NewAssignmentMessage 1111", (message: any) => {

        const taskMessage = JSON.parse(message.replace("NEW_ASSIGNMENT:", ""));
        console.log("SignalR NewAssignmentMessage", taskMessage);
        if (props.onNewAssignmentMessage) {
            props.onNewAssignmentMessage("NewAssignmentMessage", taskMessage);
        }
    });

    return null; // Replace with valid JSX if needed
}
export default SignalTaskServiceModel
